import { useContext } from 'react';
import { MissionControlUpdatesContext } from './viewController';

export const useMissionControlUpdatesContext = () => useContext(MissionControlUpdatesContext);
